import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { AiOutlineSave } from 'react-icons/ai'
import { Modal as AntModal } from 'reactstrap'

import { CloseIcon } from '../../../icons'
import { Input } from '../../../input'
import { Button } from '../../../buttons'
import { CustomDatePicker } from '../../../datepicker'
import { CompanyInfoFirstCol } from './first-column'
import { CompanyInfoSecondCol } from './second-column'
import { selectList } from '../../types'
import { employeeMovementSchema } from '../../schema/movement-schema'

import { FONTS } from '../../../../constants'

export const CreateMovementForm = props => {
  const {
    isCreate,
    setIsCreate,
    movementData,
    handleClickCreate,
    isEditCompany,
    _companys,
    _lobs,
    _positions,
    _departments,
    _divisions,
    _teams,
  } = props
  const [detailState, setDetailState] = useState({})
  const [invalid, setInvalid] = useState({})

  useEffect(() => {
    defaultInvalidInput()
  }, [])

  useEffect(() => {
    if (movementData) {
      setDetailState({
        ...movementData,
        name: '',
        start_date: null,
        description: '',
      })
    }
  }, [movementData, isCreate])

  const defaultInvalidInput = () => {
    const requiredFields = {}
    const movementKeys = Object.keys(employeeMovementSchema)
    movementKeys.map(key => {
      if (employeeMovementSchema[key].required) {
        requiredFields[key] = true
      }
      return key
    })
    delete requiredFields['email']
    setInvalid(requiredFields)
  }

  const handleInput = (e, name) => {
    if (name === 'company_id') {
      setDetailState({
        ...detailState,
        [name]: e.value,
        lob_id: '',
        department_id: '',
      })
    } else if (name === 'lob_id') {
      setDetailState({
        ...detailState,
        [name]: e.value,
        department_id: '',
      })
    } else if (name === 'adjust_after_complete') {
      setDetailState({ ...detailState, [e.target.name]: e.target.checked })
    } else if (selectList.indexOf(name) > -1) {
      setDetailState({ ...detailState, [name]: e.value })
    } else {
      setDetailState({ ...detailState, [name]: e })
    }
    if (employeeMovementSchema[name].required
      && (e === '' || (e && e.value === '') || e === null)) {
      setInvalid({ ...invalid, [name]: true })
    } else if (invalid[name] && !(e === '' || e.value === '')) {
      const _invalid = { ...invalid }
      delete _invalid[name]
      setInvalid(_invalid)
    }
  }

  const cancelCreateMovement = () => {
    setDetailState({})
    defaultInvalidInput()
    setIsCreate(false)
  }

  return (
    <Modal
      isOpen={ isCreate }
      toggle={ cancelCreateMovement }
    >
      <ModalHeader>
        <Header>New Movement</Header>
        <CloseIcon onClick={ cancelCreateMovement } />
      </ModalHeader>
      <Container>
        <MovementSection>
          <FormGroup>
            <FormWrapper>
              <Label required>Movement Name</Label>
              <Input
                name='name'
                placeholder='Enter Movement Name'
                invalid={ invalid['name'] }
                value={ detailState.name || '' }
                onChange={ e => handleInput(e.target.value, 'name') }
              />
            </FormWrapper>
            <FormWrapper>
              <Label required>Start Date</Label>
              <CustomDatePicker
                showYearDropdown
                showMonthDropdown
                autoComplete='off'
                name='start_date'
                invalid={ invalid['start_date'] }
                dateFormat='DD/MM/YYYY'
                selected={ detailState.start_date ? moment(detailState.start_date) : null }
                onChange={ e => handleInput(e, 'start_date') }
              />
            </FormWrapper>
          </FormGroup>
          <FormGroup>
            <MovementWrapper>
              <Label>Description (Remarks)</Label>
              <Input
                name='description'
                placeholder='Enter Description'
                value={ detailState.description || '' }
                onChange={ e => handleInput(e.target.value, 'description') }
              />
            </MovementWrapper>
          </FormGroup>
        </MovementSection>
        <Form>
          <CompanyInfoFirstCol
            _companys={ _companys }
            _lobs={ _lobs }
            _positions={ _positions }
            _departments={ _departments }
            movementData={ detailState }
            isEditCompany={ isEditCompany }
            handleInput={ handleInput }
          />
          <CompanyInfoSecondCol
            _divisions={ _divisions }
            _teams={ _teams }
            movementData={ detailState }
            isEditCompany={ isEditCompany }
            handleInput={ handleInput }
          />
        </Form>
      </Container>
      <Footer>
        <ButtonGroup>
          <Button
            theme='#28a745'
            icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
            width='70px'
            height='26px'
            disabled={ Object.keys(invalid).length > 0 }
            onClick={ () => {
              handleClickCreate(detailState)
              defaultInvalidInput()
              setDetailState({})
            } }
          >
          Save
          </Button>
          <Button
            theme='#6c757d'
            width='70px'
            height='26px'
            onClick={ cancelCreateMovement }
          >
          Cancel
          </Button>
        </ButtonGroup>
      </Footer>
    </Modal>
  )
}

const Modal = styled(AntModal)`
  max-width: 100%;
  display: flex;
  justify-content: center;

  .modal-content {
      width: 700px;
  }
`

const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px 0 16px;
`

const Header = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #333333;
`

const Footer = styled.div`
  height: 42px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #F9F9F9;
  padding: 0 16px;
`

const Label = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #808080;

  ${p => p.required && `
      ::after {
        content: '*';
        color: red;
      }
    `}
`

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  :nth-child(1) {
      padding-right: 6px;
  }

  :nth-last-child(1) {
      padding-left: 6px;
  }
`

const ButtonGroup = styled.div`
  display: flex;

  div:nth-child(1) {
    margin-right: 12px;
  }
`

const Container = styled.div`
  padding: 16px 24px;
  background: #FFFFFF;
  max-height: calc(100vh - 240px);
  overflow-y: scroll;
`

const Form = styled.div`
  display: flex;
  background: #F9F9F9;
  border: 1px solid #EAEAEA;
  border-radius: 4px;
  padding: 12px;
`

const FormGroup = styled.div`
  display: flex;
  margin-bottom: 16px;
`

const MovementSection = styled.div`
  display: flex;
  flex-direction: column;
`

const MovementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`



// WEBPACK FOOTER //
// ./src/components/new-employee/movement/create-movement/index.js